<template>
  <div :style="`opacity: ${opaqueMode ? 1 : 0.5}; flex-grow: 1;`">
    <v-textarea
      v-model="text"
      :readonly="readOnlyMode"
      label="JSON"
      auto-grow
      rows="12"
      hide-details
      class="json-textarea"
      @blur="onBlur" />
    <div
      style="margin-top: 8px; color: var(--v-theme-onSurface); font-size: 12px">
      <span
        v-if="error"
        style="color: var(--v-error)">
        Invalid JSON: {{ error }}
      </span>
      <span v-else>Valid JSON</span>
    </div>
  </div>
</template>
<script setup>
import { deluge } from '@/stores/deluge.js';
import { defineProps, onMounted, ref, watch, computed } from 'vue';
import PinBtn from './PinBtn.vue';
import PinAutoRefreshBtn from './PinAutoRefreshBtn.vue';
import PinSendNowBtn from './PinSendNowBtn.vue';
import { inheritanceHandler } from '../../../utils/inheritanceHandler';
import { isOpaque } from './utils.js';

const props = defineProps([
  'currentTemplate',
  'resetFunc',
  'originLevel',
  'item',
  'myKey',
  'hideicons',
  'hide_pin_controls',
  'hide_activate_controls',
  'readOnlyMode',
]);
const opaqueMode = computed(() => {
  return isOpaque(deluge, props);
});
const text = ref('');
const error = ref(null);

function normalizeInitial() {
  const v = props.item?.value;
  if (v === undefined || v === null) {
    text.value = '';
    return;
  }
  try {
    if (typeof v === 'object') {
      text.value = JSON.stringify(v, null, 2);
    } else if (
      (typeof v === 'string' && v.trim().startsWith('{')) ||
      (typeof v === 'string' && v.trim().startsWith('['))
    ) {
      const parsed = JSON.parse(v);
      text.value = JSON.stringify(parsed, null, 2);
    } else {
      text.value = String(v);
    }
  } catch (e) {
    text.value = String(v);
  }
}

onMounted(() => {
  normalizeInitial();
});

const unLockedMode = ref(props.item?.keyInherited);

watch(
  () => props.item?.value,
  () => {
    inheritanceHandler(props.item);
    normalizeInitial();
  },
  { immediate: true }
);

function onBlur() {
  // Validate JSON; if valid, store compact JSON string; otherwise keep text and set error
  const t = text.value;
  error.value = null;
  if (t.trim() === '') {
    props.item.value = '';
    return;
  }
  try {
    // try parse
    const parsed = JSON.parse(t);
    props.item.value = JSON.stringify(parsed);
    // reformat text to pretty printed
    text.value = JSON.stringify(parsed, null, 2);
  } catch (e) {
    // Not valid JSON; store raw text
    props.item.value = t;
    error.value = e.message;
  }
}
</script>
<style scoped>
.json-textarea {
  min-height: 220px;
}
</style>
